import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Response } from "../shared/models/Response";
import { CertificadoDigital } from "src/app/models/CertificadoDigital/CertificadoDigital";
import { TokenStorageService } from "./token-storage.service";
import { finalize, map } from "rxjs/operators";
import { CertificadoRequest } from "../models/Emisor/EmisorWizardRequest";
import { CertificadoDigitalFilter } from "../models/CertificadoDigital/CertificadoDigitalFilter";
import { Page } from "../shared/models/Page";
import { PagedResponse } from "../shared/models/PagedResponse";
import { CertificadoFileObject } from "../models/CertificadoDigital/CertificadoFileObject";
import { CertificadoDigitalRequest } from 'src/app/models/CertificadoDigital/CertificadoDigitalRequest';
import { RevocacionRequest } from "../models/CertificadoDigital/RevocacionRequest";
import { CertificadoCompraWizard } from "src/app/models/Emisor/EmisorWizardRequest";


@Injectable({
	providedIn: "root",
})
export class CertificadosDigitalesService {
	private REST_API_SERVER = environment.backend_server + "/certificado";
	isLoadingCertificateSummary: Observable<boolean>;
	private loadingCertificateSummarySubject: BehaviorSubject<boolean>;
	constructor(private http: HttpClient, private tokenService: TokenStorageService) {
		this.loadingCertificateSummarySubject = new BehaviorSubject<boolean>(true);
		this.isLoadingCertificateSummary = this.loadingCertificateSummarySubject.asObservable();
	}

	getDataByPage(filtro: CertificadoDigitalFilter, page: Page): Observable<PagedResponse<CertificadoDigital>> {
		let emisorId = filtro.emisorId ? filtro.emisorId : "";
		return this.http.get<PagedResponse<CertificadoDigital>>(this.REST_API_SERVER + "/list/filter/?emisorId=" + emisorId + "&Rut=" + (filtro.rut != undefined ? filtro.rut : "") + "&Nombre=" + (filtro.nombre != undefined ? filtro.nombre : "") + "&Activo=" + filtro.activo + "&EmisorRut=" + filtro.EmisorRut  + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize);
	}
	public getData(emisorId): Observable<any> {
		this.loadingCertificateSummarySubject.next(true);
		return this.http.get<any>(this.REST_API_SERVER + "/list?emisorId=" + emisorId).pipe(finalize(() => this.loadingCertificateSummarySubject.next(false)));
	}

	public addCertificate(data: CertificadoFileObject): Observable<Response<string>> {
		data.sucursalId = this.tokenService.getSubsidiary();
		data.EmisorRut = this.tokenService.getCompanyRut();
		let formData = new FormData();
		formData.append("certificadoString", JSON.stringify(data));
		formData.append("file", data.file);
		return this.http.post<any>(this.REST_API_SERVER + "/upload", formData);
	}

	public delete(certificado: CertificadoDigital, emisorId: string): Observable<Response<any>> {
		return this.http.post<any>(this.REST_API_SERVER + "/delete?certificadoId=" + certificado.certificadoDigitalId + "&emisorId=" + emisorId, null);
	}
	public validateCertificate(certificado: CertificadoRequest): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/validateCertificate", certificado);
	}

	public downloadCertificateRequest(row: CertificadoDigital): Observable<Response<any>> {
		return this.http.get<Response<any>>(this.REST_API_SERVER + "/downloadCertificate?CertificateId=" + row.certificadoDigitalId);
	}

	public getPassword(row: CertificadoDigital): Observable<Response<any>> {
		return this.http.get<Response<any>>(this.REST_API_SERVER + "/getPassword?CertificateId=" + row.certificadoDigitalId);
	}

	public deactivateCertificate(row: CertificadoDigital, emisorId: string): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/deactivate?certificadoId=" + row.certificadoDigitalId + "&emisorId=" + emisorId, null);
	}

	public reactivateCertificate(row: CertificadoDigital, emisorId: string): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/activate?certificadoId=" + row.certificadoDigitalId + "&emisorId=" + emisorId, null);
	}
	public initTransbank(payload: CertificadoDigitalRequest, certificadoId?: string, emisorId?: string) {
		const params: any = {};
		if (certificadoId) params.certificadoId = certificadoId;
		if (emisorId) params.emisorId = emisorId;

		return this.http.post<any>(`${this.REST_API_SERVER}/init-transbank`, payload, { params });
	}


	initTransbankReposicion(certificadoId: string, emisorId: string, request: CertificadoRequest) {
		return this.http.post<any>(`${this.REST_API_SERVER}/init-transbank-reposicion?certificadoId=${certificadoId}&emisorId=${emisorId}`,request);
	}
	
	revocar(dto: RevocacionRequest): Observable<Response<boolean>> {
		const fd = this.toFormData(dto);
		return this.http.post<Response<boolean>>(`${this.REST_API_SERVER}/revocacion`, fd);
	}
	downloadRevocationLetter(certificadoId: string): Observable<Blob> {
		const url = `${this.REST_API_SERVER}/revocacion/carta?certificadoId=${certificadoId}`;
		return this.http.get(url, { responseType: 'blob' });
	}
	  private toFormData(dto: RevocacionRequest): FormData {
		const fd = new FormData();
		// campos escalares
		fd.append('CertificadoId',    dto.certificadoId);
		fd.append('NombreCompleto',   dto.NombreCompleto);
		fd.append('Rut',              dto.Rut);
		fd.append('CorreoContacto',   dto.CorreoContacto);
		if (dto.TelefonoContacto)     fd.append('TelefonoContacto', dto.TelefonoContacto);
		if (dto.Comentarios)          fd.append('Comentarios',      dto.Comentarios);
		// ficheros bajo la misma clave "Archivos"
		dto.Archivos.forEach(f => fd.append('Archivos', f, f.name));
		return fd;
	  }

	getTarifasCertificado(): Observable<any[]> {
		return this.http.get<any>(`${this.REST_API_SERVER}/tarifas`).pipe(
			map(resp => resp.data)
		);
	}
	getCertificadoDigital(emisorId: string): Observable<Response<any>> {
		return this.http.get<Response<any>>(`${this.REST_API_SERVER}/ObtenerCertificado/${emisorId}`);
	}


}
